import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class MostAccessedTable extends Component {
  state = {}

  renderHeaders = (lsBranches) => {
    const { translate } = this.props

    const branchHeaders = Object.keys(lsBranches).map((key, i) => (
      <th key={i} className='align-center hidden-column overflow-hidden-column'>{`${key} - ${lsBranches[key]}`}</th>
    ))

    return (
      <tr>
        <th className='align-left hidden-column overflow-hidden-column'>
          {translate('analytics.functionality')}
        </th>
        {branchHeaders}
      </tr>
    )
  }

  renderRows = (lsMenus, lsBranches, lsAccesses) => {
    const { translate } = this.props

    const menuLines = Object.keys(lsMenus).map((keyMenu, i) => {
      const branchColumns = Object.keys(lsBranches).map((keyBranch, i) => {
        const itemArray = lsAccesses.filter(
          (i) =>
            parseInt(i.idBranch, 10) === parseInt(keyBranch, 10) &&
            i.cdMenu === parseInt(keyMenu, 10)
        )

        let count
        if (itemArray.length > 0) {
          count = itemArray[0].count
        } else {
          count = 0
        }

        return <td key={i} className='align-center'>{count}</td>
      })
      let formattedCodMenu = ''
      if (lsMenus[keyMenu].dsMenuTranslated.startsWith('%%')) {
        formattedCodMenu = translate(lsMenus[keyMenu].dsMenu)
      } else {
        formattedCodMenu = lsMenus[keyMenu].dsMenuTranslated
      }
      return (
        <tr key={i}>
          <td>{formattedCodMenu}</td>
          {branchColumns}
        </tr>
      )
    })

    return <tbody>{menuLines}</tbody>
  }

  render() {
    const { accesses, translate, fetchReports } = this.props

    return (
      <div className='MostAccessedTable'>
        <Row>
          <Col xs={11}>
            <legend>{translate('analytics.most-accessed')}</legend>
          </Col>
          <Col xs={1}>
            <legend onClick={fetchReports} style={{ cursor: 'pointer' }}>
              {translate('option.btn.export')}
            </legend>
          </Col>
        </Row>

        <Col xs={12} className='sticky-headers-table-container'>
          <table className='sticky-headers-table table-zebra margin-top'>
            <thead>
              {accesses &&
                accesses.lsBranches &&
                this.renderHeaders(accesses.lsBranches)}
            </thead>
            {accesses &&
              accesses.lsMenus &&
              this.renderRows(
                accesses.lsMenus,
                accesses.lsBranches,
                accesses.lsAccesses
              )}
          </table>
        </Col>
      </div>
    )
  }
}

MostAccessedTable.propTypes = {
  accesses: PropTypes.object,
  translate: PropTypes.func.isRequired,
  fetchReports: PropTypes.func.isRequired,
}

export default MostAccessedTable
